import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 99 インフラ情報（流域下水道）の同意ウィンドウ
 * 
 * @returns 
 */
const Component = () => {

    const { state, dispatch } = useContext(Context);
    let [isOpened, setIsOpened] = useState(true);

    /**
     * 同意した場合はフラグをtrueにする。
     */
    const agree = () => {

        // vis99の3メニュー共通の同意のキーはメニューの1つである99_1としておく。
        dispatch({
            type    : 'SET_MODAL_AGREE',
            category: "vis_99_1"
        })
        
        setIsOpened(false)
    }
    
    const disAgree = () => {
        setIsOpened(false)
    }

    return (isOpened && <>
        <div class="modal-first">
            <div class="modal-first-inner">

                <h3 className="u-fs-16 u-txt-c u-pb-xs u-lh-sm">「広島県下水道GISデータ」　ご利用規約</h3>

                <p className="u-pb-xs">本サイトで公開する「広島県下水道GISデータ」（以下、「本データ」という）をご利用いただく前に、以下の注意点を必ずお読みください。</p>

                <section className="u-pb-xs">
                    <h5 style={{}}><strong>＜本データについて＞</strong></h5>
                    <p>本データは、広島県が管理する流域下水道施設の参考図としてご利用いただくものです。以下の特性をご理解の上、お使いください。</p>

                    <ul>
                        <li><strong>・誤差の存在</strong><br />
                            本データは、地図及びGISデータ作成上の誤差を含んでおり、本データの完全なる正確性を保証するものではありません。
                        </li>
                        <li><strong>・情報の時点</strong><br />
                            背景として表示される地形や建物、道路などの情報は、データ作成時点のものであり、現在の状況と異なる場合があります。<br />
                            本データは、予告なく更新されることがあり、常に最新の情報を保証するものではありません。
                        </li>
                        <li><strong>・権利関係について</strong><br />
                            本データは、施設の参考情報であり、土地の所有権等の権利関係を示すものではありません。
                        </li>
                        <li><strong>・その他</strong><br />
                            広島県は、本データの利用によって発生する直接または間接の損失、損害について一切の責任を負いません。
                        </li>
                    </ul>
                </section>

                <section className="u-pb-xs">
                    <h5 style={{}}><strong>＜お問い合わせ・各種手続き＞</strong></h5>
                    <p>より正確な情報が必要な場合や、法令に基づく手続きについては、下記のとおりご対応をお願いします。</p>

                    <ul>
                        <li><strong>・内容の確認</strong><br />
                            流域下水道台帳の閲覧、記載内容に関する詳細なご確認については、担当課までお問い合わせください。
                        </li>
                        <li><strong>・流域下水道施設付近での工事</strong><br />
                            流域下水道施設の付近で掘削を伴う工事は、施設の破損を防ぐため、必ず事前に担当課へご連絡の上、協議を行ってください。
                        </li>
                    </ul>
                </section>

                <section className="u-pb-xs">
                    <p><strong>【お問い合わせ先】</strong><br /> 広島県上下水道部流域下水道課　電話番号: 082-513-4352</p>
                </section>

                <h4>上記利用上の注意事項について、全て同意しますか。</h4>

                <p className="u-txt-c" onClick={agree} style={{ cursor: 'pointer' }} ><span style={{"text-decoration": "underline"}}>同意します</span></p>
                <p className="u-txt-c" onClick={disAgree} style={{fontSize:"0.7em", cursor: 'pointer' }}><span style={{"text-decoration": "underline"}}>同意しません</span></p>
            </div>
        </div>
    </>);
}

export default Component
